import { FormikValues } from "formik";
import { Dto } from "../../app/parts/crud/dto";
import { processDelete, processGet, processPost, processPut} from "../api"



export class CrudAPI {
  private id: number | string | null = null;
  private _handleSubmitted: (data: any) => void = (data: any) => {};
  private _handleBeforeSubmitted: (data: any) => {} = (data: any) => {return data};
  rawData: any;
  constructor(public api:string, private dto: Dto){
    this.dto.handleOnSubmit(async (values: any) => {
      return await this.submit(values);
    });
    this.dto.handleOnSubmitCustom(async (values: any,path:string,method:string = "PUT") => {
      return await this.customSubmit(values, path, method);
    });
  
  }

  async otherValidation(values:FormikValues,id:number|null){
    return this.dto.otherValidation(values,id);
  }

  handleSubmitted(callback: (data: any) => void){
    this._handleSubmitted = callback;
  }

  handleBeforeSubmit(callback: (data: any) => {} = (data: any) => {return data}){

    this._handleBeforeSubmitted = callback;
  }

  getRawData(){
    return this.rawData;
  }

  async createFromCustomGet(apiPath: string){
    let data:any = await processGet(apiPath);
    this.rawData = data.data;
    this.dto.updateData(data);
    this.dto.hookIsEdit();
  }
  async getChart(data:any){
    let res:any = await processPost(this.api + '/chart', data);
    return res;
  }
  async customSubmit(values: any,path:string,method:string){
    values = await this._handleBeforeSubmitted(values);
    let res:any;
    if(method == "PUT"){
      res = await processPut(path, values);
    }else if(method == "POST"){
      res = await processPost(path, values);
    }
    this._handleSubmitted(res);
    return res;
  }

  async createFromId(id: number|string){
    this.id = id;
    let data:any = await processGet(this.api + '/' + id);
    this.rawData = data.data;
    this.dto.updateData(data);
    this.dto.hookIsEdit();
  
  }
  async submit(values: any){
    values = await this._handleBeforeSubmitted(values);
    if(this.id != null){
      return await this.update(this.id, values);
    }else{
      return await this.add(values);
    }

  }
async update(id: number|string, data: any){
    const res:any = await processPut(this.api + '/' + id, data);
    this._handleSubmitted(res);
    return res;
  }

  async add(data: any) {
  
    const res:any = await processPost(this.api, data);
    this._handleSubmitted(res);
    return res;
  }
  get f(){
    return this.dto.data;
  }

  get isSubmitted(){
    return this.dto.isSubmitted;
  }
  async list(params:any){
    let data:any = await processGet(this.api, params);
    return data;
  }

  async delete(id:number){
   return  await processDelete(this.api + '/' + id);
  }

  async customList(apiPath:string,params:any = {}){
    let data:any = await processGet(apiPath,params);
    return data.data;
  }
}